import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Profile } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
// import { useAuthStore } from "../../auth/stores";
// import { useProfileStore } from "./store";
import { toast } from 'react-toastify';
import { isAuth, logout } from '../auth/actions';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';

export default function ProfilePage() {
  // const [state, actions] = useProfileStore();
  const [statePageSettingHeader] = usePageSettingHeaderStore();
  // const [authState, authActions] = useAuthStore();
  // const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));

  useEffect(() => {
    document.title = `Profile - Ubaform Admin`;
  }, []);

  let contentUi = <div className='loader-block' />;
  if (!isAuth().isLoading) {
    contentUi = (
      <React.Fragment>
        <Profile stateDetail={isAuth()} />
      </React.Fragment>
    );
  }

  // console.log(isAuth().result);

  // if (!user) {
  //   toast.error('Cannot load data user profile');
  // }

  return (
    <>
      {isAuth() ? (
        <div className='App'>
          <Header />
          {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}
          <main className='workspace'>
            <section className='breadcrumb lg:flex items-start'>
              <div className='flex items-center justify-between w-full'>
                <div>
                  {' '}
                  <h1>
                    Profile <b>{isAuth().name}</b>
                  </h1>
                </div>
                <div className='space-x-2'>
                  <Link to={`/profile/edit/${isAuth()._id}`}>
                    <button className='bg-primary py-2 px-3 rounded text-white'>
                      Edit Profile
                    </button>
                  </Link>
                  <Link to={`/profile/change-password/${isAuth()._id}`}>
                    <button className='bg-yellow py-2 px-3 rounded text-gray-800'>
                      Change Password
                    </button>
                  </Link>
                </div>
              </div>
            </section>
            {contentUi}
            <Footer />
          </main>
        </div>
      ) : (
        <Redirect to='/auth' />
      )}
    </>
  );
}
